<template>
  <div class="ma-4">
    <v-row>
      <v-col>
        <span class="font-weight-black subtitle-1">RANTAI PASOK KEBUTUHAN BAHAN </span><span class="red--text">(Contoh)</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-hover v-slot="{hover }" open-delay="200">
          <v-card  class="top-gradient-teal" :elevation="hover ? 16 : 2">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="mb-4">
                      <div class="mb-4 font-weight-bold">Pemakaian Bahan</div>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-progress-circular
                              rotate="360"
                              size="100"
                              width="15"
                              color="teal"
                              value="100"
                          >
                            {{  10200 }}
                          </v-progress-circular>
                        </v-col>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-list-item-title>
                  <div class="font-weight-bold">PEMAKAIAN BAHAN</div>
                </v-list-item-title>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Kotawaringin Lama
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Pangkalan Banteng
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Pangkalan Lada
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Arut Utara
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Kumai
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Arut Selatan
                    </v-list-item-title>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item-subtitle class="gray--text">Semen 500 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir Halus 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Agregat Kasar 30 Ton</v-list-item-subtitle>
                    <v-list-item-subtitle class="gray--text">Pasir beton 30 Ton</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-col>


            </v-row>
          </v-card>
        </v-hover>
      </v-col>


    </v-row>
  </div>
</template>

<script>
export default {
  name: "Dashboard"
}
</script>

<style scoped>

</style>